import criteriaToFilterDto from './criteriaToFilterDto';
export default function transferToDto(transferInfo) {
    var _a, _b, _c;
    return {
        conditions: ((_a = transferInfo === null || transferInfo === void 0 ? void 0 : transferInfo.conditions) !== null && _a !== void 0 ? _a : []).map(function (_a) {
            var condition = _a.condition, account = _a.account;
            return ({
                condition: criteriaToFilterDto(condition),
                account: account !== null && account !== void 0 ? account : '',
            });
        }),
        else: { account: (_c = (_b = transferInfo === null || transferInfo === void 0 ? void 0 : transferInfo.else) === null || _b === void 0 ? void 0 : _b.account) !== null && _c !== void 0 ? _c : '' },
    };
}
